const React = require('react');
const ReactIntl = require('react-intl');
const injectIntl = ReactIntl.injectIntl;
const { partial, isEmpty } = require('lodash');
const { RadioButtonGroup, RadioButton, Layout, Text, Card, IconButton } = require('@metro-ui/core');
const { Edit, Trash } = require('@metro-ui/icons');
const defaultMessages = require('../../i18n/messages/default');
const EditAuthModal = require('../LoginPreferences/EditAuthModal');
const LoginActions = require('../../actions/LoginActions.js');
const LoginStore = require('../../stores/LoginStore.js');
const DeleteAuthMethodsDialogModal = require('../LoginPreferences/DeleteAuthMethodsDialogModal');

const mfaMethodsMapper = {
    ['codes_via_sms']: 'loginpreferences.2famethods.codes_via_sms.setup_multiple_2fa',
    ['codes_via_app']: 'loginpreferences.2famethods.codes_via_app.setup_multiple_2fa',
    ['webauthn']: 'loginpreferences.2famethods.webauthn.security_device'
};

class TwoFactorAuthenticationMethodsList extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            editAuthModalVisible: false,
            deleteDialogModalVisible: false,
            deleteMethodCredentialId: '',
            mfaEditPayload: {}
        };

        this.toggleEditModalVisible = this.toggleEditModalVisible.bind(this);
        this.toggleDeleteModalVisible = this.toggleDeleteModalVisible.bind(this);
        this.onRadioButtonChange = this.onRadioButtonChange.bind(this);
        this.deleteUserMFAMethodlistener = this.deleteUserMFAMethodlistener.bind(this);
    }

    componentDidMount() {
        LoginStore.addChangeUserMFAMethodListener(this.changeUserMFAMethodListener);
        LoginStore.addDeleteUserMFAMethodListener(this.deleteUserMFAMethodlistener);
    }

    componentWillUnmount(){
        LoginStore.removeChangeUserMFAMethodListener(this.changeUserMFAMethodListener);
        LoginStore.removeDeleteUserMFAMethodListener(this.deleteUserMFAMethodlistener);
    }

    changeUserMFAMethodListener() {
        const appState = LoginStore.getState();
        const { editAuthMethod: { editAuthMethodError, editAuthErrorMessage } } = appState;

        if (editAuthMethodError) {
            LoginActions.triggerToast(
                editAuthErrorMessage,
                "error",
                true
            );
        } else {
            LoginActions.triggerToast(
                this.props.intl.formatMessage(defaultMessages['loginpreferences.2fa.edit.method']),
                "success",
                true
            );
        }
    }

    deleteUserMFAMethodlistener() {
        const appState = LoginStore.getState();
        const { deleteUserMFA: { userMFAMethodError, userMFAMethodErrorMessage } } = appState;

        if (userMFAMethodError) {
            LoginActions.triggerToast(
                userMFAMethodErrorMessage,
                "error",
                true
            );
        } else {
            LoginActions.triggerToast(
                this.props.intl.formatMessage(defaultMessages['loginpreferences.2fa.remove.method']),
                "success",
                true
            );
        }
    }

    toggleEditModalVisible(payload) {
        this.setState({ editAuthModalVisible: !this.state.editAuthModalVisible, mfaEditPayload: payload });
    }

    toggleDeleteModalVisible(credentialId) {
        this.setState({ deleteDialogModalVisible: !this.state.deleteDialogModalVisible, deleteMethodCredentialId: credentialId});
    }

    onRadioButtonChange(value) {
        const { tokenId, userId, userType, countryCode } = this.props;
        const payload = { isDefault: true }
        LoginActions.changeUserMFAMethod(tokenId, userId, userType, value, payload, countryCode);
    }

    renderAuthenthificationMethodList() {
        const { userMFAMethods, intl } = this.props;

        if (!isEmpty(userMFAMethods)) {
            return userMFAMethods.map((option) => {
                return (
                    <Card padding="x-large">
                        <RadioButton value={option.credentialId}>
                            <Layout spacing="medium" align="center">
                                <Layout grow={1} spacing="medium" direction="column">
                                    <Text size='small'>{option.isDefault
                                      ? intl.formatMessage(defaultMessages['loginpreferences.2fa.methods.is_default'])
                                      : intl.formatMessage(defaultMessages['loginpreferences.2fa.methods.make_default'])}</Text>
                                    <Text className='authDeviceTitle' color='metro-blue' size='medium' hasNoNativeMargin>
                                        {option.name}
                                    </Text>
                                    <Text size='small' color='metro-blue'>{intl.formatMessage(defaultMessages[mfaMethodsMapper[option.mfaOptionType]])}</Text>
                                </Layout>
                                <Layout grow={0} spacing="medium">
                                    <IconButton Icon={Trash} label={intl.formatMessage(defaultMessages['loginpreferences.2fa.remove'])} onClick={partial(this.toggleDeleteModalVisible, option.credentialId)} 
                                    />
                                    <IconButton Icon={Edit} label={intl.formatMessage(defaultMessages['loginpreferences.2fa.edit'])} onClick={partial(this.toggleEditModalVisible, option)} />
                                </Layout>
                            </Layout>
                        </RadioButton>
                    </Card>
                )
            })
        }
        return null;
    }

    render() {
        const { tokenId, deleteAuthenticationMethod, userType, userId, userMFAMethods } = this.props;
        const { mfaEditPayload, deleteMethodCredentialId } = this.state;
        const defaultMethodId = (userMFAMethods.find(method => method.isDefault) || {}).credentialId || '';

        return (
            <>
                <RadioButtonGroup
                    name="labels"
                    value={defaultMethodId}
                    onChange={(_, newValue) => {
                        this.onRadioButtonChange(newValue)
                    }}
                >
                    {this.renderAuthenthificationMethodList()}
                </RadioButtonGroup>
                {this.state.editAuthModalVisible &&
                    <EditAuthModal
                        closeModal={partial(this.toggleEditModalVisible, 'editAuthModalVisible')}
                        name={mfaEditPayload.name}
                        credentialId={mfaEditPayload.credentialId}
                        tokenId={tokenId}
                        userType={userType}
                        userId={userId}
                    />
                }
                {this.state.deleteDialogModalVisible &&
                    <DeleteAuthMethodsDialogModal
                        closeModal={partial(this.toggleDeleteModalVisible, 'deleteMethodCredentialId')}
                        userId={userId}
                        deleteAuthenticationMethod={deleteAuthenticationMethod}
                        credentialId={deleteMethodCredentialId}
                    />
                }
            </>
        );
    }
}

module.exports = injectIntl(TwoFactorAuthenticationMethodsList);